import { useQuery } from '@tanstack/react-query';

import { organizationAppsQuery } from '../api/user-apps.api';

/**
 * Fetches the list of apps available to the signed-in user's
 * organization via the platform-api `/users/me/apps` endpoint.
 */
export const useOrganizationApps = (enabled = true) =>
  useQuery({
    ...organizationAppsQuery(),
    enabled,
  });
